import Waves from "node-waves";

function btnRipple() {
	return {
		restrict: "C",
		link: function(scope, element) {
			if(element.hasClass("btn-icon") || element.hasClass("btn-float")) {
				Waves.attach(element, ["waves-circle"]);
			} else if(element.hasClass("btn-light")) {
				Waves.attach(element, ["waves-light"]);
			} else {
				Waves.attach(element);
			}

			Waves.init();
		}
	};
}

export default angular
	.module("vesl.behaviors.btn-ripple", [])
	.directive("btn", btnRipple).name;
